import React from "react";
import "./App.css";
import QueryPage from "./components/QueryPage";
import EpcCalculator from "./components/EpcCalculator";
import Landing from "./components/Landing";
import AuditComponent from "./components/AuditCheck";
import PdfPage from "./components/pdfPage";
import KarmaPage from "./components/karma";
import ExternalPage from "./components/External";
import SMSTemplateBuilder from "./components/SMSTemplateBuilder";
import SMSWorkspace from "./components/SMSWorkspace";
import MeasuresTracker from "./components/MeasuresTracker";
import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react'; 
import { InteractionStatus } from '@azure/msal-browser';
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Routes, Route, useLocation } from "react-router-dom";
import { PageLayout,PageLayoutExt } from './components/PageLayout';
import { loginRequest } from "./authConfig";
import { useSearchParams } from 'react-router-dom';
import EPCBot from "./components/EPCBot";
import AuthErrorModal from './components/AuthErrorModal';
import setupAxiosInterceptors, { setAuthErrorCallback } from './services/axiosInterceptor';
import { JobsProvider } from './contexts/JobsContext';
import JobsToastTray from './components/JobsToastTray';
import { isSmsAdminAccount } from './utils/smsPermissions';
import { isMobileDevice } from './utils/deviceDetection';
import { setPendingRedirectTarget, consumePendingRedirectTarget } from './utils/postLoginRedirect';
//import  ExcelImport  from './pages/ExcelImport';
//import { Home } from './pages/Home';

const globalState = {
  text: "foo",
};
const globalStateContext = React.createContext(globalState);

const Pages = () => {
  const [searchParams] = useSearchParams();
  const [authError, setAuthError] = React.useState(null);
  const [showAuthErrorModal, setShowAuthErrorModal] = React.useState(false);

  /**
   * useMsal is hook that returns the PublicClientApplication instance,
   * an array of all accounts currently signed in and an inProgress value
   * that tells you what msal is currently doing. For more, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
   */
  const { instance, inProgress } = useMsal();

  // Set up global axios interceptor and auth error callback on component mount
  React.useEffect(() => {
    setupAxiosInterceptors();
    
    setAuthErrorCallback((error) => {
      console.error('[App] Global auth error:', error);
      setAuthError(error);
      setShowAuthErrorModal(true);
    });
  }, []);

  // Popup logins can leave a mobile deep-link stranded after a redirect-based
  // sign-in reloads the app, so pick the destination back up once authenticated.
  // Runs whenever MSAL finishes processing a redirect (not just on first mount),
  // and always consumes the stored target so a failed/cancelled sign-in can't
  // leave a stale destination for a later, unrelated sign-in to pick up.
  React.useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;
    const pendingTarget = consumePendingRedirectTarget();
    if (pendingTarget && instance.getActiveAccount()) {
      window.location.assign(pendingTarget);
    }
  }, [instance, inProgress]);

  const activeAccount = instance.getActiveAccount() || instance.getAllAccounts?.()[0] || null;
  const isSmsAdmin = isSmsAdminAccount(activeAccount);
/* this worker is shared between drag-drop and file input element */

  // instance.acquireTokenSilent({
  //   ...usrRequest,
  //   account: activeAccount,
  // }).then((res)=>{
  //   console.log(res);
  // });
  const WrapperComponent = (props) => {
    console.log(props);
    if (searchParams.get("id")){
      if (searchParams.get("im")==="trianco"){return <AuditComponent/>}
      else{return <AuditComponent/>}
    }else{
      return <Landing/>
    }
  }
  
      
/* when the worker sends back the HTML, add it to the DOM */
 console.log(activeAccount);

 const isExternal = (children) =>{
//if (activeAccount?.idTokenClaims?.groups?.length >0){
const username = String(activeAccount?.username || '').toLowerCase();
if (username.includes('happyenergy.co.uk')){
  return children;
}else{
  return <PageLayoutExt><ExternalPage/></PageLayoutExt>
}
 }

 const SignInRequiredRoute = ({ targetPath, title }) => {
  const [isSigningIn, setIsSigningIn] = React.useState(false);
  const [signInError, setSignInError] = React.useState('');
  const location = useLocation();

  const handleSignIn = async () => {
    setIsSigningIn(true);
    setSignInError('');

    try {
      // Popups are unreliable/silently blocked on mobile browsers and in-app webviews.
      if (isMobileDevice()) {
        setPendingRedirectTarget(`${targetPath}${location.search || ''}${location.hash || ''}`);
        // No shipped /redirect.html page for a full-page redirect; use the registered default.
        await instance.loginRedirect(loginRequest);
        return;
      }

      const result = await instance.loginPopup({
        ...loginRequest,
        redirectUri: '/redirect.html'
      });

      if (result?.account) {
        instance.setActiveAccount(result.account);
      }

      window.location.assign(`${targetPath}${location.search || ''}`);
    } catch (error) {
      console.error('[App] Sign-in failed for protected deep-link route:', error);
      setSignInError('Sign-in failed. Please try again.');
      setIsSigningIn(false);
    }
  };

  return (
    <PageLayout>
      <div className="container">
        <h5 className="mb-2">{title}</h5>
        <p className="text-muted mb-3">This page requires sign-in before it can be opened.</p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSignIn}
          disabled={isSigningIn}
        >
          {isSigningIn ? 'Signing in...' : 'Sign in to continue'}
        </button>
        {signInError && <div className="text-danger small mt-2">{signInError}</div>}
      </div>
    </PageLayout>
  );
 }

 const SmsAdminRequiredRoute = ({ children }) => {
  if (isSmsAdmin) {
    return children;
  }

  return <PageLayout><SMSWorkspace /></PageLayout>;
 }

  return (
    <>
    <AuthErrorModal 
      show={showAuthErrorModal} 
      onClose={() => setShowAuthErrorModal(false)}
      error={authError}
    />
    <AuthenticatedTemplate>
    <Routes>
        <Route path="/:id" element={<PageLayout><AuditComponent /></PageLayout>} />
        <Route path="/" element={isExternal(<PageLayout>
          < WrapperComponent/>
            </PageLayout>)} />
        <Route path="/audit/:id" element={isExternal(<PageLayout><AuditComponent/></PageLayout>)} />
        <Route path="/reg-verify/:typeIn/:idIn" element={isExternal(<PageLayout><AuditComponent/></PageLayout>)} />
        <Route path="/pdf" element={<PageLayout><PdfPage/></PageLayout>} /> 
        <Route path="/Query" element={<PageLayout><QueryPage/></PageLayout>} />
        <Route path="/karma" element={<PageLayout><KarmaPage/></PageLayout>} />
        <Route path="/external" element={<PageLayout><ExternalPage/></PageLayout>} /> 
        <Route path="/epcBot" element={<PageLayout><EPCBot/></PageLayout>} /> 
        <Route path="/sms" element={<PageLayout><SMSWorkspace/></PageLayout>} />
        <Route path="/sms-templates" element={<SmsAdminRequiredRoute><PageLayout><SMSTemplateBuilder/></PageLayout></SmsAdminRequiredRoute>} />
        <Route path="/sms-conversations" element={<PageLayout><SMSWorkspace/></PageLayout>} />
        <Route path="/measures" element={<PageLayout><MeasuresTracker/></PageLayout>} />
        <Route path="/EPCcalc" element={
        <DndProvider backend={HTML5Backend}>
        <PageLayout>< EpcCalculator/></PageLayout>
        </DndProvider>} />
        {/* <redirect to ="/audit" />  */}
    </Routes>
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
    <Routes>
    <Route path="/:id" element={<PageLayout><AuditComponent /></PageLayout>} />
    <Route path="/" element={<PageLayout>
          < WrapperComponent/></PageLayout>} />
    {/* <Route path=":im" element={<PageLayout><AuditComponent/></PageLayout>} />
    <Route path=":id" element={<PageLayout><AuditComponent /></PageLayout>} /> */}
    <Route path="/audit/:id" element={<PageLayout><AuditComponent/></PageLayout>} />
    <Route path="/reg-verify/:typeIn/:idIn" element={<PageLayout><AuditComponent/></PageLayout>} />
    <Route path="/pdf" element={<PageLayout><PdfPage/></PageLayout>} /> 
    <Route path="/epcBot" element={<PageLayout><EPCBot/></PageLayout>} /> 
    <Route path="/external" element={<PageLayoutExt><ExternalPage/></PageLayoutExt>} /> 
    <Route path="/sms" element={<SignInRequiredRoute targetPath="/sms" title="SMS" />} />
    <Route path="/sms-conversations" element={<SignInRequiredRoute targetPath="/sms-conversations" title="SMS Conversations" />} />
    <Route path="/sms-templates" element={<SignInRequiredRoute targetPath="/sms-templates" title="SMS Templates" />} />
    </Routes>
    </UnauthenticatedTemplate>
     </>
  );


  

};




const App = ({ instance }) => {
  return (
     <main> 
      
          <MsalProvider instance={instance}>
          <globalStateContext.Provider value={globalState}>
            {/* <PageLayout> */}
            <JobsProvider>
                <Pages />
                <JobsToastTray />
            </JobsProvider>
            {/* </PageLayout> */}
            </globalStateContext.Provider>
        </MsalProvider>
        
     </main>
  );
}

export default App;
